import React from 'react'
import cx from 'classnames'

import TabbedContentBase, { TabbedContentBaseProps, Tab } from 'components/ui/tabbedContent/TabbedContentBase/TabbedContentBase'

import { useMemo } from 'sb-hooks'
import s from './UnderscoreTabbedContent.scss'


// omitting obligatory field styles
export type UnderscoreTabbedContentProps = Omit<TabbedContentBaseProps, 'styles'> & {
  uppercase?: boolean
  semibold?: boolean
  tabPadding?: 'after' | 'inner' | false
  tabs?: Tab[]
}

const UnderscoreTabbedContent: React.FunctionComponent<UnderscoreTabbedContentProps> = (props) => {
  const { uppercase = true, semibold, tabPadding = 'after', ...rest } = props

  const styles = useMemo(() => ({
    ...s,
    tab: cx(s.tab, {
      [s.semibold]: semibold,
      [s.uppercase]: uppercase,
      [s.tabPaddingInner]: tabPadding === 'inner',
    }),
    tabContainer: cx(s.tabContainer, {
      [s.tabContainerPaddingAfter]: tabPadding === 'after',
    }),
  }), [ semibold, uppercase, tabPadding ])

  return (
    <TabbedContentBase styles={styles} {...rest} />
  )
}


export default UnderscoreTabbedContent
